import S3 from "aws-s3";


const identityPoolId = "sa-east-1:da2e6ddc-3e9b-472e-9e4f-b1b564b0c689";



function sendPgdasd(codigoPortalPrefeitura, file, resultCallBack) {

    const config = {
        bucketName: "trimap-pgdasd",
        dirName: codigoPortalPrefeitura,
        region: "sa-east-1",
        accessKeyId: "AKIAZYLHZ6JHNEOEGSSX",
        secretAccessKey: "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",
    }
    
    const ReactS3Client = new S3(config);
    /*  Notice that if you don't provide a dirName, the file will be automatically uploaded to the root of your bucket */
    
    ReactS3Client
        .uploadFile(file, file.name)
        .then(_ => {
            if (resultCallBack != undefined) {
                resultCallBack({ arquivo: file.name, sucesso: true });
            }
        })
        .catch(error => {
            if (resultCallBack != undefined) {
                resultCallBack({ arquivo: file.name, sucesso: false, error: error });
            }
        });
};


export default sendPgdasd;

